import PropTypes from 'prop-types';

/**
 * Core
 */
export const urlGenerator = PropTypes.shape({
    route: PropTypes.func.isRequired,
});

export const history = PropTypes.shape({
    listen: PropTypes.func.isRequired,
});

export const intl = PropTypes.shape({
    locale: PropTypes.string.isRequired,
    formatMessage: PropTypes.func.isRequired,
});

export const message = PropTypes.shape({
    id: PropTypes.string.isRequired,
    defaultMessage: PropTypes.string,
});

export const text = PropTypes.oneOfType([message, PropTypes.string]);

export const label = PropTypes.oneOfType([message, PropTypes.node]);

export const color = PropTypes.oneOfType([PropTypes.string]);

export const statusCode = PropTypes.oneOf([401, 403, 404, 500]);

/**
 * Site
 */
export const user = PropTypes.shape({
    id: PropTypes.number,
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    email: PropTypes.string,
    gender: PropTypes.string,
    birthdate: PropTypes.string,
});

export const menuItem = PropTypes.shape({
    label,
    url: PropTypes.string,
    external: PropTypes.bool,
    active: PropTypes.bool,
});
export const menuItems = PropTypes.arrayOf(menuItem);

export const page = PropTypes.shape({
    id: PropTypes.number,
    url: PropTypes.string,
});

export const pages = PropTypes.arrayOf(page);

export const menus = PropTypes.shape({
    main: PropTypes.object, // eslint-disable-line
    footer: PropTypes.object, // eslint-disable-line
    archives: PropTypes.arrayOf(PropTypes.object),
    social: PropTypes.arrayOf(PropTypes.object),
});

export const borders = PropTypes.shape({
    top: PropTypes.bool,
    right: PropTypes.bool,
    bottom: PropTypes.bool,
    left: PropTypes.bool,
});

/**
 * Forms
 */
export const errors = PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]);
export const formErrors = PropTypes.objectOf(errors);

export const selectOption = PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
});
export const selectOptions = PropTypes.arrayOf(selectOption);

export const formField = PropTypes.shape({
    value: PropTypes.any, // eslint-disable-line
    name: PropTypes.string,
});
export const formFields = PropTypes.objectOf(formField);

/**
 * Blocks
 */

export const components = PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
);

export const block = PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    type: PropTypes.string.isRequired,
});

export const blocks = PropTypes.arrayOf(block);

export const image = PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
    sizes: PropTypes.shape({
        thumbnail: PropTypes.string,
        small: PropTypes.string,
        medium: PropTypes.string,
        large: PropTypes.string,
    }),
});
export const images = PropTypes.arrayOf(image);

export const download = PropTypes.shape({
    src: PropTypes.string,
});
export const downloads = PropTypes.arrayOf(download);

export const link = PropTypes.shape({
    url: PropTypes.string,
    label: PropTypes.string,
});
export const links = PropTypes.arrayOf(link);
